// One page section of the flow Pages tab (flow language).
export const T = {
  en_GB: {
    edit: "Edit",
    repeated: "Repeated",
    addPage: "Add Page",
    name: "Name",
    noPagesYet: "No pages yet",
    components: "Components",
    component: "component",
    delete: "Delete",
  },
  nb_NO: {
    edit: "Rediger",
    repeated: "Gjentas",
    addPage: "Legg til side",
    name: "Navn",
    noPagesYet: "Ingen sider ennå",
    components: "Komponenter",
    component: "komponent",
    delete: "Slett",
  },
} as const;
